<template>
  <v-container>
    <v-card>
      <v-card-title>Giclee Sizes</v-card-title>
      <v-card-text>
        <v-data-table
          v-if="sizes.length"
          :items="sizes"
          :headers="headers"
          :disable-pagination="true"
          :hide-default-footer="true"
          dense
          ></v-data-table>
      </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import ProductApi from '@/api/admin/product'

export default {
  components: {
  },
  data() {
    return {
      sizes: [],
      headers: [
        { text: 'Edition', value: 'editionType' },
        { text: 'Width', value: 'gicleeWidth' },
        { text: 'Height', value: 'gicleeHeight' },
        { text: 'Mounted Width', value: 'gicleeMountedWidth' },
        { text: 'Mounted Height', value: 'gicleeMountedHeight' },
        { text: 'Title', value: 'title' },
      ],
    }
  },
  async created() {
    ProductApi.loadAllGicleeSizes().then( res => {
      this.sizes = res.data
    }
  )
  },
  mounted: function () {
  },
  computed: {
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep tbody tr :hover {
  cursor: pointer;
}
</style>
